var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-box"},[_c('div',{class:[
      'answer-box__options',
      _vm.center ? 'answer-box__options--center' : '',
      _vm.right ? 'answer-box__options--right' : '',
      _vm.type == 'image' || _vm.type == 'video' ? 'answer-box__options--images' : ''
    ]},_vm._l((_vm.values),function(value,index){return _c('div',{key:index,class:[
        _vm.type == 'text' ? 'answer-box__option' : '',
        _vm.type == 'image' || _vm.type == 'video' ? 'answer-box__image' : '',
        _vm.type == 'video' ? 'answer-box__video' : ''
      ],on:{"click":function($event){return _vm.toggleOption(_vm.type, value, index)}}},[_vm._v(" "+_vm._s(_vm.type == "text" ? value : "")+" "),(_vm.type == 'image')?_c('img',{attrs:{"src":value,"alt":"Akan SMB"}}):_vm._e(),(_vm.type == 'video')?_c('img',{attrs:{"src":value.cover,"alt":"Akan SMB"}}):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }